<template>
    <div>
        <h2 v-html="$t('intern_inserieren.titel_kontaktdaten')"></h2>
        <adresse         @initial="initial" @ADDRESS_STORED="weiter(tabName)" :isTab="true" class="mt-5"/>
        <invoice-address @initial="initial"@ADDRESS_STORED="weiter(tabName)" class="mb-5"/>
    </div>
</template>

<script>
    import Adresse        from '../../../views/konto/Adresse';
    import InvoiceAddress from '../booking/InvoiceAddress';
    import EventBus       from '../../../EventBus';
    import Booking        from '../../../classes/Booking';

    export default {
        data() {
            return {
                tabName: 'ADDRESS',
                addressExist: false
            }
        },
        components: {
            Adresse,
            InvoiceAddress
        },
        methods: {
            weiter(tab) {
                if(tab == this.tabName && this.addressExist){
                    if(this.$cookies.isKey('currentBooking')){
                        this.$store.state.loading = true;

                        let bookingJSON  = this.$cookies.get('currentBooking');
                        let booking      = Booking.getObjectFromJSON(bookingJSON);
                        let improvements = [];
                        let arrayImprovements = booking.getImprovementObjects();

                        if(arrayImprovements){
                            improvements = arrayImprovements.map(item => item.article_key);
                        }

                        let data         = {
                            packet: booking.getPacket().id,
                            improvements: improvements,
                            object_id: booking.getObjectId()
                        };

                        this.$http.post('/userPacketApi/createPacket', data).then( response => {
                            booking.setArticleCount(response.data);
                            booking.setActiveTab('payment');
                            this.$emit('nextTab', booking);
                            this.$store.state.loading = false;
                        }).catch( error => {
                            this.$store.state.loading = false;
                            console.log(error);
                        });
                    }
                }else if(tab == this.tabName && !this.addressExist){
                    this.$bvModal.msgBoxOk('Bitte geben Sie Ihre Adresse an', {
                        okTitle: 'Schließen',
                        okVariant: 'danger'
                    });
                }
            },
            back() {
                this.$emit('moveTo', 'improvement');
            },
            initial(val) {
                this.addressExist = val;
            }
        },
        created () {
            EventBus.$on('NEXT_EMIT_TO_CHILD', this.weiter);
            EventBus.$on('BACK_EMIT_TO_CHILD', this.back);
        },
        beforeDestroy () {
            EventBus.$off('NEXT_EMIT_TO_CHILD', this.weiter);
            EventBus.$off('BACK_EMIT_TO_CHILD', this.back);
        },
    }
</script>

<style scoped>

</style>
